import React from 'react';
import VoiceToTextTextarea from '@components/VoiceToTextTextarea';
import { AboutMeTypes } from '../StepThreeTypes';
import getVoiceToTextBlockedMessages from './VoiceTranscribing/utils';

interface WhoImportantToMeProps {
  aboutMe: AboutMeTypes;
  setAboutMe: (aboutMe: AboutMeTypes) => void;
}

const WhoImportantToMe: React.FC<WhoImportantToMeProps> = ({
  aboutMe,
  setAboutMe,
}) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h1 className="govuk-label-wrapper">
        <label
          className="govuk-label govuk-label--l"
          htmlFor="who-important-to-me"
        >
          People who are important to me
        </label>
      </h1>
      <div className="govuk-body">
        Details of who is important to you and why. They could be family
        members, carers, friends, members of staff etc. Include how you want the
        people important to you to be engaged and involved in your care and
        support in both emergency and normal situations. Include how you stay
        connected to the people important to you. Who should not be contacted or
        consulted about your care and support and why, if you wish to say.
      </div>

      <details className="govuk-details">
        <summary className="govuk-details__summary">
          <span className="govuk-details__summary-text">Prompt questions</span>
        </summary>
        <div className="govuk-details__text">
          <div className="govuk-body">
            1. Who are the important people in your life and why? Think about
            family, friends, staff in the care home and people who support you
            at home or in the community or at a club.
          </div>
          <div className="govuk-body">
            2. Who should be contacted in an emergency and why?
          </div>
          <div className="govuk-body">
            3. Who do you want to be consulted on, and involved in, your care
            and support in an emergency and in normal situations?
          </div>
          <div className="govuk-body">
            4. Is there anyone that should not be contacted or consulted about
            your care and support and why (if you wish to say)?
          </div>
        </div>
      </details>
      <VoiceToTextTextarea
        id="who-important-to-me"
        name="whoImportantToMe"
        value={aboutMe.whoImportantToMe || ''}
        rows={5}
        autoComplete="bio"
        placeholder="Type here or use voice to text..."
        recordBlockedErrors={getVoiceToTextBlockedMessages(aboutMe)}
        onChange={value =>
          setAboutMe({
            ...aboutMe,
            whoImportantToMe: value,
          })
        }
      />
    </div>
  );
};

export default WhoImportantToMe;
